/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
function checkurl(taglink){										
    let url = taglink.prop("href")
		fetch(url, { method: 'get', redirect: 'follow'})
    .then(response => {
      if(response.status==200 && response.redirected)
			{
				taglink.attr('href',response.url); 
				taglink.removeAttr('target');
			}else if(response.status==404){
				taglink.after(taglink.html());
                taglink.remove();
			}
			else{
   		   //taglink.prop('rel','nofollow');
			//taglink.removeAttr('target');
			}
    })
    .catch(function(err) {
        console.info(err + " url: " + url);
    });
											
	}
$( document ).ready(function() {
  $(".product-block-list__item--description a,.article__inner a").each(function(){
    checkurl($(this));
  })
});
$(".card__header .collection-btn-view-more").on("click",function(){
  if($(".card__header").hasClass("h-header-collection")){
    $(".card__header").removeClass("h-header-collection");
    $(".card__header .collection-btn-view-more").html("<span>Rút gọn nội dung</span>");
  }else{
    $(".card__header").addClass("h-header-collection");
    $(".card__header .collection-btn-view-more").html('<span class="btn-viewmore">Xem thêm nội dung</span>');
  }
  
})
